import React from "react";
import "./Basket_crane_rental.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Basket_crane_rental() {
  return (
    <div className="Crane_work_nationwide-page">

      {/* =====================================================
          HERO - כותרת עליונה
      ===================================================== */}

      <div className="Basket_crane_rental-hero">

        <div className="Basket_crane_rental-overlay">
          <h1>השכרת מנוף סל</h1>
        </div>

      </div>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              השכרת מנוף סל
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/26.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את שירותי השכרת מנוף הסל של נצר הובלות ומנופים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            השכרת מנוף סל מאפשרת לבצע עבודות הרמה ועבודה בגובה
            במגוון תנאים ובמקומות שבהם נדרשת גישה בטוחה ונוחה.
            נצר הובלות ומנופים מספקת שירותי השכרת מנוף סל לקבלנים,
            חברות, עסקים, אנשי מקצוע ולקוחות פרטיים, בהתאם לסוג
            העבודה, לגובה הנדרש ולתנאי השטח.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/38.jpeg"
                alt="השכרת מנוף סל"
              />
            </div>

            <div className="text-box">

              <p>
                השכרת מנוף סל דורשת התאמה בין סוג העבודה, גובה
                העבודה, תנאי השטח ומיקום המשאית. לפני ביצוע העבודה
                חשוב לבחון את גובה ההרמה, אזור העבודה, תנאי הגישה
                והאפשרות להציב את המנוף במקום המתאים.
              </p>

              <p>
                נצר הובלות ומנופים מספקת פתרונות לעבודות בגובה
                באמצעות מנוף סל, לרבות עבודות תחזוקה, גיזום,
                התקנות, עבודות חשמל, שילוט, ניקוי ועבודות נוספות,
                בהתאם לסוג המשימה ולתנאים בשטח.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            השכרת מנוף סל – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל עבודה עם מנוף סל מתחילה בבדיקת פרטי העבודה.
              יש להבין מה גובה העבודה, מהו סוג המשימה, כמה זמן
              נדרש המנוף ומהם תנאי השטח במקום.
            </p>

            <p>
              בנוסף יש לבחון את נקודת ההצבה של המשאית, את תנאי
              הגישה ואת המרחב הנדרש לביצוע העבודה בצורה מסודרת.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              מנוף סל לעבודות בגובה
            </h2>

            <p>
              מנוף סל מאפשר להעלות אנשי מקצוע אל גובה העבודה
              ולבצע משימות במקומות שבהם עבודה מהקרקע אינה אפשרית.
              השימוש במנוף מתאים למגוון עבודות בהתאם לדרישות הפרויקט.
            </p>

            <p>
              ניתן להשתמש במנוף סל לעבודות תחזוקה, התקנה, תיקון,
              גיזום, שילוט, ניקוי ועבודות נוספות הדורשות גישה
              לגובה.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              השכרת מנוף סל לאתרי בנייה ולעסקים
            </h2>

            <p>
              באתרי בנייה, מפעלים, עסקים ומבנים פרטיים יש לעיתים
              צורך בעבודה בגובה לצורך התקנת ציוד, תחזוקת מבנים,
              שילוט, תאורה ועבודות נוספות.
            </p>

            <p>
              נצר הובלות ומנופים מספקת שירותי השכרת מנוף סל
              לאתרי בנייה, עסקים, מפעלים ולמגוון נקודות ברחבי
              הארץ, בהתאם לצורכי הלקוח ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              מנוף סל לגיזום עצים
            </h2>

            <p>
              עבודות גיזום של עצים גבוהים עשויות לדרוש גישה
              בטוחה לגובה. מנוף סל יכול לאפשר הגעה אל אזורי
              העבודה בהתאם לתנאי השטח ולמיקום העץ.
            </p>

            <p>
              לפני העבודה יש לבדוק את מיקום העץ, תנאי הגישה,
              אפשרויות הצבת המשאית והגובה הנדרש לביצוע העבודה.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              מנוף סל לעבודות תחזוקה והתקנה
            </h2>

            <p>
              מנוף סל מתאים למגוון עבודות תחזוקה והתקנה, כגון
              התקנת שלטים, גופי תאורה, מצלמות, מערכות, ניקוי
              מבנים ועבודות נוספות המבוצעות בגובה.
            </p>

            <p>
              בהתאם לסוג העבודה ניתן לתכנן את העבודה כך שהמנוף
              יוצב בנקודה המתאימה ויאפשר גישה נוחה לאזור העבודה.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להשכרת מנוף סל?
            </h2>

            <p>
              עבודה בגובה דורשת תכנון מוקדם, התאמת ציוד מתאים
              ובדיקה של תנאי השטח. תכנון נכון יכול לסייע בביצוע
              העבודה בצורה מסודרת ובהתאם לדרישות הפרויקט.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון מנוף הסל לסוג
              העבודה, לגובה הנדרש, לתנאי הגישה ולדרישות הלקוח.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – השכרת מנוף סל בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי השכרת מנוף סל
              לעבודות בגובה לקבלנים, חברות, עסקים, אנשי מקצוע
              ולקוחות פרטיים. השירות ניתן בהתאם לסוג העבודה,
              לגובה הנדרש ולתנאים הקיימים בשטח.
            </p>

            <p>
              צריכים מנוף סל? צרו איתנו קשר, ספרו לנו מה גובה
              העבודה, מה סוג המשימה והיכן היא מתבצעת, ונבחן עבורכם
              את פתרון העבודה המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Renting_a_basket_crane_for_lifting_a_person"
              className="link-right"
            >
השכרת מנוף סל להרמת אדם            </Link>

            <Link
              to="/Crane_Rental1"
              className="link-left"
            >
          השכרת מנוף זרוע
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
